// @ts-check

import BaseModel from "@kaspernj/api-maker/build/base-model.js"
import Collection from "@kaspernj/api-maker/build/collection.js"
import Activity from "./activity.js"
import Contact from "./contact.js"
import Organization from "./organization.js"
import User from "./user.js"

const modelClassData = {
  "attributes": {
    "activity_id": {
      "column": {
        "default": null,
        "name": "activity_id",
        "null": false,
        "type": "uuid"
      },
      "name": "activity_id",
      "selected_by_default": null,
      "translated": null
    },
    "approved_by_id": {
      "column": {
        "default": null,
        "name": "approved_by_id",
        "null": true,
        "type": "uuid"
      },
      "name": "approved_by_id",
      "selected_by_default": null,
      "translated": null
    },
    "contact_id": {
      "column": {
        "default": null,
        "name": "contact_id",
        "null": false,
        "type": "uuid"
      },
      "name": "contact_id",
      "selected_by_default": null,
      "translated": null
    },
    "created_at": {
      "column": {
        "default": null,
        "name": "created_at",
        "null": false,
        "type": "datetime"
      },
      "name": "created_at",
      "selected_by_default": null,
      "translated": null
    },
    "enrolled_by_id": {
      "column": {
        "default": null,
        "name": "enrolled_by_id",
        "null": true,
        "type": "uuid"
      },
      "name": "enrolled_by_id",
      "selected_by_default": null,
      "translated": null
    },
    "id": {
      "column": {
        "default": null,
        "name": "id",
        "null": false,
        "type": "uuid"
      },
      "name": "id",
      "selected_by_default": null,
      "translated": null
    },
    "participant_number": {
      "column": {
        "default": 0,
        "name": "participant_number",
        "null": false,
        "type": "integer"
      },
      "name": "participant_number",
      "selected_by_default": null,
      "translated": null
    },
    "participant_type": {
      "column": {
        "default": "participant",
        "name": "participant_type",
        "null": false,
        "type": "string"
      },
      "name": "participant_type",
      "selected_by_default": null,
      "translated": null
    },
    "registered_by_id": {
      "column": {
        "default": null,
        "name": "registered_by_id",
        "null": true,
        "type": "uuid"
      },
      "name": "registered_by_id",
      "selected_by_default": null,
      "translated": null
    },
    "state": {
      "column": {
        "default": "registered",
        "name": "state",
        "null": false,
        "type": "string"
      },
      "name": "state",
      "selected_by_default": null,
      "translated": null
    },
    "unregistered_by_id": {
      "column": {
        "default": null,
        "name": "unregistered_by_id",
        "null": true,
        "type": "uuid"
      },
      "name": "unregistered_by_id",
      "selected_by_default": null,
      "translated": null
    },
    "guest_token": {
      "column": {
        "default": null,
        "name": "guest_token",
        "null": false,
        "type": "string"
      },
      "name": "guest_token",
      "selected_by_default": null,
      "translated": null
    },
    "translated_participant_type": {
      "column": null,
      "name": "translated_participant_type",
      "selected_by_default": false,
      "translated": null
    },
    "translated_state": {
      "column": null,
      "name": "translated_state",
      "selected_by_default": false,
      "translated": null
    }
  },
  "className": "ActivityParticipant",
  "collectionKey": "activity_participants",
  "collectionName": "activity_participants",
  "i18nKey": "activity_participant",
  "camelizedLower": "activityParticipant",
  "name": "ActivityParticipant",
  "nameDasherized": "activity-participant",
  "pluralName": "activity_participants",
  "ransackable_associations": [
    {
      "className": "Activity",
      "collectionName": "activities",
      "foreignKey": "activity_id",
      "name": "activity",
      "macro": "belongs_to",
      "resource_name": "Activity",
      "through": null
    },
    {
      "className": "User",
      "collectionName": "users",
      "foreignKey": "approved_by_id",
      "name": "approved_by",
      "macro": "belongs_to",
      "resource_name": "User",
      "through": null
    },
    {
      "className": "Contact",
      "collectionName": "contacts",
      "foreignKey": "billing_contact_id",
      "name": "billing_contact",
      "macro": "belongs_to",
      "resource_name": "Contact",
      "through": null
    },
    {
      "className": "Contact",
      "collectionName": "contacts",
      "foreignKey": "contact_id",
      "name": "contact",
      "macro": "belongs_to",
      "resource_name": "Contact",
      "through": null
    },
    {
      "className": "User",
      "collectionName": "users",
      "foreignKey": "enrolled_by_id",
      "name": "enrolled_by",
      "macro": "belongs_to",
      "resource_name": "User",
      "through": null
    },
    {
      "className": "ActivityParticipant",
      "collectionName": "activity_participants",
      "foreignKey": "invited_by_id",
      "name": "guests",
      "macro": "has_many",
      "resource_name": "ActivityParticipant",
      "through": null
    },
    {
      "className": "ICalendar",
      "collectionName": null,
      "foreignKey": "resource_id",
      "name": "i_calendar",
      "macro": "has_one",
      "resource_name": null,
      "through": null
    },
    {
      "className": "ActivityParticipant",
      "collectionName": "activity_participants",
      "foreignKey": "invited_by_id",
      "name": "invited_by",
      "macro": "belongs_to",
      "resource_name": "ActivityParticipant",
      "through": null
    },
    {
      "className": "Log",
      "collectionName": "logs",
      "foreignKey": "trackable_id",
      "name": "logs",
      "macro": "has_many",
      "resource_name": "Log",
      "through": null
    },
    {
      "className": "Person",
      "collectionName": "people",
      "foreignKey": "person_id",
      "name": "person",
      "macro": "has_one",
      "resource_name": "Person",
      "through": "contact"
    },
    {
      "className": "User",
      "collectionName": "users",
      "foreignKey": "registered_by_id",
      "name": "registered_by",
      "macro": "belongs_to",
      "resource_name": "User",
      "through": null
    },
    {
      "className": "Organization",
      "collectionName": "organizations",
      "foreignKey": "school_id",
      "name": "school",
      "macro": "has_one",
      "resource_name": "Organization",
      "through": "contact"
    },
    {
      "className": "Tagging",
      "collectionName": "taggings",
      "foreignKey": "resource_id",
      "name": "taggings",
      "macro": "has_many",
      "resource_name": "Tagging",
      "through": null
    },
    {
      "className": "Tag",
      "collectionName": "tags",
      "foreignKey": "tag_id",
      "name": "tags",
      "macro": "has_many",
      "resource_name": "Tag",
      "through": "taggings"
    },
    {
      "className": "Tenant",
      "collectionName": "tenants",
      "foreignKey": "tenant_id",
      "name": "tenant",
      "macro": "belongs_to",
      "resource_name": "Tenant",
      "through": null
    },
    {
      "className": "User",
      "collectionName": "users",
      "foreignKey": "unregistered_by_id",
      "name": "unregistered_by",
      "macro": "belongs_to",
      "resource_name": "User",
      "through": null
    },
    {
      "className": "WorkerPlugins::WorkplaceLink",
      "collectionName": "workplace_links",
      "foreignKey": "resource_id",
      "name": "workplace_links",
      "macro": "has_many",
      "resource_name": "WorkplaceLink",
      "through": null
    }
  ],
  "ransackable_attributes": [
    {
      "name": "activity_id",
      "column": {
        "default": null,
        "name": "activity_id",
        "null": false,
        "type": "uuid"
      }
    },
    {
      "name": "approved_by_id",
      "column": {
        "default": null,
        "name": "approved_by_id",
        "null": true,
        "type": "uuid"
      }
    },
    {
      "name": "billing_contact_id",
      "column": {
        "default": null,
        "name": "billing_contact_id",
        "null": true,
        "type": "uuid"
      }
    },
    {
      "name": "contact_id",
      "column": {
        "default": null,
        "name": "contact_id",
        "null": false,
        "type": "uuid"
      }
    },
    {
      "name": "created_at",
      "column": {
        "default": null,
        "name": "created_at",
        "null": false,
        "type": "datetime"
      }
    },
    {
      "name": "enrolled_by_id",
      "column": {
        "default": null,
        "name": "enrolled_by_id",
        "null": true,
        "type": "uuid"
      }
    },
    {
      "name": "guest_token",
      "column": {
        "default": null,
        "name": "guest_token",
        "null": false,
        "type": "string"
      }
    },
    {
      "name": "id",
      "column": {
        "default": null,
        "name": "id",
        "null": false,
        "type": "uuid"
      }
    },
    {
      "name": "id_string",
      "column": null
    },
    {
      "name": "invited_by_id",
      "column": {
        "default": null,
        "name": "invited_by_id",
        "null": true,
        "type": "uuid"
      }
    },
    {
      "name": "microsoft_identifier",
      "column": {
        "default": null,
        "name": "microsoft_identifier",
        "null": true,
        "type": "string"
      }
    },
    {
      "name": "old_activity_id",
      "column": {
        "default": null,
        "name": "old_activity_id",
        "null": true,
        "type": "integer"
      }
    },
    {
      "name": "old_approved_by_id",
      "column": {
        "default": null,
        "name": "old_approved_by_id",
        "null": true,
        "type": "integer"
      }
    },
    {
      "name": "old_billing_contact_id",
      "column": {
        "default": null,
        "name": "old_billing_contact_id",
        "null": true,
        "type": "integer"
      }
    },
    {
      "name": "old_contact_id",
      "column": {
        "default": null,
        "name": "old_contact_id",
        "null": true,
        "type": "integer"
      }
    },
    {
      "name": "old_enrolled_by_id",
      "column": {
        "default": null,
        "name": "old_enrolled_by_id",
        "null": true,
        "type": "integer"
      }
    },
    {
      "name": "old_id",
      "column": {
        "default": null,
        "name": "old_id",
        "null": true,
        "type": "integer"
      }
    },
    {
      "name": "old_invited_by_id",
      "column": {
        "default": null,
        "name": "old_invited_by_id",
        "null": true,
        "type": "integer"
      }
    },
    {
      "name": "old_registered_by_id",
      "column": {
        "default": null,
        "name": "old_registered_by_id",
        "null": true,
        "type": "integer"
      }
    },
    {
      "name": "old_unregistered_by_id",
      "column": {
        "default": null,
        "name": "old_unregistered_by_id",
        "null": true,
        "type": "integer"
      }
    },
    {
      "name": "participant_number",
      "column": {
        "default": 0,
        "name": "participant_number",
        "null": false,
        "type": "integer"
      }
    },
    {
      "name": "participant_type",
      "column": {
        "default": "participant",
        "name": "participant_type",
        "null": false,
        "type": "string"
      }
    },
    {
      "name": "registered_by_id",
      "column": {
        "default": null,
        "name": "registered_by_id",
        "null": true,
        "type": "uuid"
      }
    },
    {
      "name": "state",
      "column": {
        "default": "registered",
        "name": "state",
        "null": false,
        "type": "string"
      }
    },
    {
      "name": "tenant_id",
      "column": {
        "default": null,
        "name": "tenant_id",
        "null": false,
        "type": "uuid"
      }
    },
    {
      "name": "unregistered_by_id",
      "column": {
        "default": null,
        "name": "unregistered_by_id",
        "null": true,
        "type": "uuid"
      }
    },
    {
      "name": "updated_at",
      "column": {
        "default": null,
        "name": "updated_at",
        "null": false,
        "type": "datetime"
      }
    }
  ],
  "ransackable_scopes": [
    {
      "name": "in_current_workplace"
    },
    {
      "name": "soft_deleted_filter"
    },
    {
      "name": "sort_by_in_current_workplace_asc"
    },
    {
      "name": "sort_by_in_current_workplace_desc"
    }
  ],
  "relationships": [
    {
      "className": "User",
      "collectionName": "users",
      "foreignKey": "approved_by_id",
      "name": "approved_by",
      "macro": "belongs_to",
      "resource_name": "User",
      "through": null
    },
    {
      "className": "Activity",
      "collectionName": "activities",
      "foreignKey": "activity_id",
      "name": "activity",
      "macro": "belongs_to",
      "resource_name": "Activity",
      "through": null
    },
    {
      "className": "Contact",
      "collectionName": "contacts",
      "foreignKey": "contact_id",
      "name": "contact",
      "macro": "belongs_to",
      "resource_name": "Contact",
      "through": null
    },
    {
      "className": "User",
      "collectionName": "users",
      "foreignKey": "enrolled_by_id",
      "name": "enrolled_by",
      "macro": "belongs_to",
      "resource_name": "User",
      "through": null
    },
    {
      "className": "ActivityParticipant",
      "collectionName": "activity_participants",
      "foreignKey": "invited_by_id",
      "name": "guests",
      "macro": "has_many",
      "resource_name": "ActivityParticipant",
      "through": null
    },
    {
      "className": "ActivityParticipant",
      "collectionName": "activity_participants",
      "foreignKey": "invited_by_id",
      "name": "invited_by",
      "macro": "belongs_to",
      "resource_name": "ActivityParticipant",
      "through": null
    },
    {
      "className": "User",
      "collectionName": "users",
      "foreignKey": "registered_by_id",
      "name": "registered_by",
      "macro": "belongs_to",
      "resource_name": "User",
      "through": null
    },
    {
      "className": "Organization",
      "collectionName": "organizations",
      "foreignKey": "school_id",
      "name": "school",
      "macro": "has_one",
      "resource_name": "Organization",
      "through": "contact"
    }
  ],
  "paramKey": "activity_participant",
  "primaryKey": "id"
}

/** Frontend model for ActivityParticipant. */
export default class ActivityParticipant extends BaseModel {
  /** @returns {typeof modelClassData} */
  static modelClassData() {
    return modelClassData
  }

  /** @returns {string} */
  activityId() {
    return this.readAttributeUnderscore("activity_id")
  }

  /** @returns {boolean} */
  hasActivityId() {
    const value = this.activityId()

    return this._isPresent(value)
  }

  /** @returns {string | null} */
  approvedById() {
    return this.readAttributeUnderscore("approved_by_id")
  }

  /** @returns {boolean} */
  hasApprovedById() {
    const value = this.approvedById()

    return this._isPresent(value)
  }

  /** @returns {string} */
  contactId() {
    return this.readAttributeUnderscore("contact_id")
  }

  /** @returns {boolean} */
  hasContactId() {
    const value = this.contactId()

    return this._isPresent(value)
  }

  /** @returns {Date} */
  createdAt() {
    return this.readAttributeUnderscore("created_at")
  }

  /** @returns {boolean} */
  hasCreatedAt() {
    const value = this.createdAt()

    return this._isPresent(value)
  }

  /** @returns {string | null} */
  enrolledById() {
    return this.readAttributeUnderscore("enrolled_by_id")
  }

  /** @returns {boolean} */
  hasEnrolledById() {
    const value = this.enrolledById()

    return this._isPresent(value)
  }

  /** @returns {string} */
  id() {
    return this.readAttributeUnderscore("id")
  }

  /** @returns {boolean} */
  hasId() {
    const value = this.id()

    return this._isPresent(value)
  }

  /** @returns {number} */
  participantNumber() {
    return this.readAttributeUnderscore("participant_number")
  }

  /** @returns {boolean} */
  hasParticipantNumber() {
    const value = this.participantNumber()

    return this._isPresent(value)
  }

  /** @returns {string} */
  participantType() {
    return this.readAttributeUnderscore("participant_type")
  }

  /** @returns {boolean} */
  hasParticipantType() {
    const value = this.participantType()

    return this._isPresent(value)
  }

  /** @returns {string | null} */
  registeredById() {
    return this.readAttributeUnderscore("registered_by_id")
  }

  /** @returns {boolean} */
  hasRegisteredById() {
    const value = this.registeredById()

    return this._isPresent(value)
  }

  /** @returns {string} */
  state() {
    return this.readAttributeUnderscore("state")
  }

  /** @returns {boolean} */
  hasState() {
    const value = this.state()

    return this._isPresent(value)
  }

  /** @returns {string | null} */
  unregisteredById() {
    return this.readAttributeUnderscore("unregistered_by_id")
  }

  /** @returns {boolean} */
  hasUnregisteredById() {
    const value = this.unregisteredById()

    return this._isPresent(value)
  }

  /** @returns {string} */
  guestToken() {
    return this.readAttributeUnderscore("guest_token")
  }

  /** @returns {boolean} */
  hasGuestToken() {
    const value = this.guestToken()

    return this._isPresent(value)
  }

  /** @returns {any} */
  translatedParticipantType() {
    return this.readAttributeUnderscore("translated_participant_type")
  }

  /** @returns {boolean} */
  hasTranslatedParticipantType() {
    const value = this.translatedParticipantType()

    return this._isPresent(value)
  }

  /** @returns {any} */
  translatedState() {
    return this.readAttributeUnderscore("translated_state")
  }

  /** @returns {boolean} */
  hasTranslatedState() {
    const value = this.translatedState()

    return this._isPresent(value)
  }

  /**
   * @template TCommandResponse
   * @param {Record<string, any> | HTMLFormElement | FormData} args
   * @param {Record<string, any>} [commandArgs]
   * @returns {Promise<TCommandResponse>}
   */
  adminStateCall(args, commandArgs = {}) {
    return /** @type {Promise<TCommandResponse>} */ (this._callMemberCommand(
      {
        args,
        command: "admin_state_call",
        primaryKey: this.primaryKey(),
        collectionName: "activity_participants",
        type: "member"
      },
      commandArgs
    ))
  }

  /**
   * @template TCommandResponse
   * @param {Record<string, any> | HTMLFormElement | FormData} args
   * @param {Record<string, any>} [commandArgs]
   * @returns {Promise<TCommandResponse>}
   */
  regretUnregister(args, commandArgs = {}) {
    return /** @type {Promise<TCommandResponse>} */ (this._callMemberCommand(
      {
        args,
        command: "regret_unregister",
        primaryKey: this.primaryKey(),
        collectionName: "activity_participants",
        type: "member"
      },
      commandArgs
    ))
  }

  /** @returns {import("./user.js").default | null} */
  approvedBy() {
    return this._readBelongsToReflection({modelClass: User, reflectionName: "approved_by"})
  }

  /** @returns {Promise<import("./user.js").default | null>} */
  loadApprovedBy() {
    if (!("approvedById" in this)) throw new Error("Foreign key method wasn't defined: approvedById")

    const id = this.approvedById()
    const ransack = {}

    ransack["id_eq"] = id

    return this._loadBelongsToReflection(
      {
        reflectionName: "approved_by",
        model: this,
        modelClass: User
      },
      {ransack}
    )
  }

  /** @returns {Promise<import("./user.js").default | null>} */
  ensureApprovedByLoaded() {
    return this.ensureAssociationLoaded("approved_by")
  }

  /** @returns {import("./activity.js").default | null} */
  activity() {
    return this._readBelongsToReflection({modelClass: Activity, reflectionName: "activity"})
  }

  /** @returns {Promise<import("./activity.js").default | null>} */
  loadActivity() {
    if (!("activityId" in this)) throw new Error("Foreign key method wasn't defined: activityId")

    const id = this.activityId()
    const ransack = {}

    ransack["id_eq"] = id

    return this._loadBelongsToReflection(
      {
        reflectionName: "activity",
        model: this,
        modelClass: Activity
      },
      {ransack}
    )
  }

  /** @returns {Promise<import("./activity.js").default | null>} */
  ensureActivityLoaded() {
    return this.ensureAssociationLoaded("activity")
  }

  /** @returns {import("./contact.js").default | null} */
  contact() {
    return this._readBelongsToReflection({modelClass: Contact, reflectionName: "contact"})
  }

  /** @returns {Promise<import("./contact.js").default | null>} */
  loadContact() {
    if (!("contactId" in this)) throw new Error("Foreign key method wasn't defined: contactId")

    const id = this.contactId()
    const ransack = {}

    ransack["id_eq"] = id

    return this._loadBelongsToReflection(
      {
        reflectionName: "contact",
        model: this,
        modelClass: Contact
      },
      {ransack}
    )
  }

  /** @returns {Promise<import("./contact.js").default | null>} */
  ensureContactLoaded() {
    return this.ensureAssociationLoaded("contact")
  }

  /** @returns {import("./user.js").default | null} */
  enrolledBy() {
    return this._readBelongsToReflection({modelClass: User, reflectionName: "enrolled_by"})
  }

  /** @returns {Promise<import("./user.js").default | null>} */
  loadEnrolledBy() {
    if (!("enrolledById" in this)) throw new Error("Foreign key method wasn't defined: enrolledById")

    const id = this.enrolledById()
    const ransack = {}

    ransack["id_eq"] = id

    return this._loadBelongsToReflection(
      {
        reflectionName: "enrolled_by",
        model: this,
        modelClass: User
      },
      {ransack}
    )
  }

  /** @returns {Promise<import("./user.js").default | null>} */
  ensureEnrolledByLoaded() {
    return this.ensureAssociationLoaded("enrolled_by")
  }

  /** @returns {import("@kaspernj/api-maker/build/collection.js").default<typeof import("./activity-participant.js").default>} */
  guests() {
    if (!("id" in this)) throw new Error("No such primary key method: id")

    const ransack = {}

    ransack["invited_by_id_eq"] = this.id()

    return new Collection(
      {
        reflectionName: "guests",
        model: this,
        modelClass: ActivityParticipant
      },
      {ransack}
    )
  }

  /** @returns {Promise<Array<import("./activity-participant.js").default>>} */
  loadGuests() {
    if (!("id" in this)) throw new Error("No such primary key method: id")

    const ransack = {}

    ransack["invited_by_id_eq"] = this.id()

    return this._loadHasManyReflection(
      {
        reflectionName: "guests",
        model: this,
        modelClass: ActivityParticipant
      },
      {ransack}
    )
  }

  /** @returns {Promise<Array<import("./activity-participant.js").default>>} */
  ensureGuestsLoaded() {
    return this.ensureAssociationLoaded("guests")
  }

  /** @returns {import("./activity-participant.js").default | null} */
  invitedBy() {
    return this._readBelongsToReflection({modelClass: ActivityParticipant, reflectionName: "invited_by"})
  }

  /** @returns {Promise<import("./activity-participant.js").default | null>} */
  loadInvitedBy() {
    if (!("invitedById" in this)) throw new Error("Foreign key method wasn't defined: invitedById")

    const id = this.invitedById()
    const ransack = {}

    ransack["id_eq"] = id

    return this._loadBelongsToReflection(
      {
        reflectionName: "invited_by",
        model: this,
        modelClass: ActivityParticipant
      },
      {ransack}
    )
  }

  /** @returns {Promise<import("./activity-participant.js").default | null>} */
  ensureInvitedByLoaded() {
    return this.ensureAssociationLoaded("invited_by")
  }

  /** @returns {import("./user.js").default | null} */
  registeredBy() {
    return this._readBelongsToReflection({modelClass: User, reflectionName: "registered_by"})
  }

  /** @returns {Promise<import("./user.js").default | null>} */
  loadRegisteredBy() {
    if (!("registeredById" in this)) throw new Error("Foreign key method wasn't defined: registeredById")

    const id = this.registeredById()
    const ransack = {}

    ransack["id_eq"] = id

    return this._loadBelongsToReflection(
      {
        reflectionName: "registered_by",
        model: this,
        modelClass: User
      },
      {ransack}
    )
  }

  /** @returns {Promise<import("./user.js").default | null>} */
  ensureRegisteredByLoaded() {
    return this.ensureAssociationLoaded("registered_by")
  }

  /** @returns {import("./organization.js").default | null} */
  school() {
    return this._readHasOneReflection({modelClass: Organization, reflectionName: "school"})
  }

  /** @returns {Promise<import("./organization.js").default | null>} */
  loadSchool() {
    if (!("id" in this)) throw new Error("Primary key method wasn't defined: id")

    const id = this.id()

    return this._loadHasOneReflection(
      {
        reflectionName: "school",
        model: this,
        modelClass: Organization
      },
      {
        params: {
          through: {
            model: "ActivityParticipant",
            id,
            reflection: "school"
          }
        }
      }
    )
  }

  /** @returns {Promise<import("./organization.js").default | null>} */
  ensureSchoolLoaded() {
    return this.ensureAssociationLoaded("school")
  }
}
